import { registerWidget } from "dmeditor";
import { definition } from "./definition";
import { BridgeSpill } from "./BridgeSpill";

export default () => {
  registerWidget(definition, {
    render: BridgeSpill,
  });
};
